import { Injectable, EventEmitter } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from './base.service';
import { environment } from 'src/environments/environment';
import { IGrid } from 'src/app/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProviderService extends BaseService {


  userName = new EventEmitter<string>();

  apiUrl = environment.apiUrl;
  tokenUrl = 'Token';

  private httpHeaders = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  });

  options = {
    headers: this.httpHeaders
  };

  constructor(http: HttpClient) {
    super(http);
  }

  login(login: string, password: string) {
    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', login)
      .set('password', password);

    return this.post(this.tokenUrl, body, this.options);
  }

  getTokenWithRefreshToken(refreshToken: string): any {
    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', refreshToken);
    return this.post(this.tokenUrl, body.toString(), this.options);
  }

  setGrid(grid: IGrid): Observable<IGrid> {
    const url = 'Grids/Set';
    return this.post(url, grid);
  }

}
